export const parseRegex = (v) => {
  return v
    .split("")
    .map((c) => {
      if ("[]\\^$.|?*+()".indexOf(c) >= 0) return "";
      else return c;
    })
    .join("");
};
